var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 531.728,
    height: 454.121,
    viewBox: "0 0 531.728 454.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.j{fill:#fff;}.ad,.ae,.b{fill:#ffc9b0;}.aj,.c{opacity:0.8;}.d{fill:#b8e5ff;}.ak,.e,.g{fill:#94d5ff;}.ab,.aj,.al,.am,.f,.i,.m,.s{fill:#50bcff;}.g{opacity:0.68;}.h{fill:#ffd245;}.i{opacity:0.4;}.j{opacity:0.83;}.k{opacity:0.36;}.l,.p,.q{fill:#004dbe;}.ab,.m{opacity:0.38;}.n,.w,.y{fill:#f59711;}.ak,.n{opacity:0.51;}.o{fill:#f55e11;opacity:0.5;}.p{opacity:0.54;}.q{opacity:0.45;}.ab,.ad,.ae,.ai,.al,.q,.s,.v,.x,.y,.z{mix-blend-mode:multiply;isolation:isolate;}.r{clip-path:url(#a);}.s{opacity:0.24;}.t{clip-path:url(#b);}.u,.x,.z{fill:#d44459;}.v{fill:#663bff;opacity:0.29;}.ae,.x{opacity:0.3;}.y{opacity:0.27;}.z{opacity:0.1;}.aa{fill:#ffa18b;}.ac{clip-path:url(#c);}.af{clip-path:url(#d);}.ag{opacity:0.21;}.ah{fill:#c72c19;}.al{opacity:0.35;}.am{opacity:0.46;}.an{fill:#414379;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M191.442,364.052s-23.329,4.62-17.882,10.047,36.477,10.619,37.972,8.547,6.1-17.459,6.1-17.459l-21.543-9.731Z",
    transform: "translate(-172.735 -355.456)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.935,375.656s-19.52,13.585-12.356,16.373,37.675-4.894,38.215-7.393-1.41-18.44-1.41-18.44l-23.636-.278Z",
    transform: "translate(-202.999 -365.918)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.823,255.593c-2.151-31.634-3.6-39.5-7.3-44.133-3.667-4.589-17.2-6.6-26.723-6.969s-23.431,2.318-27.388,5.03-6.342,14.248-5.729,28.589c.531,12.422,3.145,25.624,3.039,31.373-.194,10.673-2.29,14.789-3.813,22.731,11.907,8.287,58,12.73,67.887,10.746C330.772,292.167,330.863,270.908,329.823,255.593Z",
    transform: "translate(-261.912 -204.457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M277.926,197.372l16.231-2.348,1.775,13.377a3.48,3.48,0,0,1-.784,2.7,13.893,13.893,0,0,1-9.182,5c-4.978.582-5.607-1.7-5.538-3.125a17.166,17.166,0,0,0-.345-3.95Z",
    transform: "translate(-277.926 -195.024)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(57.08 -49.076)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.08 76.717)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.074 177.472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.006 216.56)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-4.878,427.684H-9.86l-.63-21.933H2.1Z",
    transform: "translate(10.49 -405.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M73.916,427.684H78.9l.631-21.933H66.94Z",
    transform: "translate(24.601 -405.751)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 117.218,
    height: 215.52,
    transform: "translate(3.461 3.557)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.387 19.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 97.367,
    height: 42.351
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.478,
    cy: 6.478,
    r: 6.478,
    transform: "translate(42.205 14.697)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46.873)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 97.367,
    height: 42.351
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.478,
    cy: 6.478,
    r: 6.478,
    transform: "translate(42.205 14.697)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 93.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 97.367,
    height: 42.351
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.478,
    cy: 6.478,
    r: 6.478,
    transform: "translate(42.205 14.697)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 140.619)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 97.367,
    height: 42.351
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 6.478,
    cy: 6.478,
    r: 6.478,
    transform: "translate(42.205 14.697)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 124.14,
    height: 8.135,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.535 9.532)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.217,104.028c-1.4-3.885,1.53-8.9,5.36-11.416,2.557-1.682,5.521-2.762,7.1-4.976a14.943,14.943,0,0,1-2.86,8.254A24.445,24.445,0,0,1,20.217,104.028Z",
    transform: "translate(-10.627 -79.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M21.638,105.757c.54-2.14-1.719-4.167-3.153-5.331a47.522,47.522,0,0,1-4.344-3.491A8.475,8.475,0,0,1,14.4,85.5c-.885.76.492,3.327.917,3.989a28.114,28.114,0,0,0,3.856,4.018C22.244,96.652,22.767,101.275,21.638,105.757Z",
    transform: "translate(-12.05 -79.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.971,102.377c-.706-1.96,1.331-4.329,2.63-5.711a54.068,54.068,0,0,0,3.926-4.14c2.444-3.236,2.1-8.579-1.192-10.925.921.577-.2,3.281-.56,3.991a31.471,31.471,0,0,1-3.418,4.548C19.619,93.719,19.493,98.271,20.971,102.377Z",
    transform: "translate(-10.596 -80.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.569,102.059c-.7-.169-1.383-1.1-1.719-1.591a7.745,7.745,0,0,1-1.2-3.118c-.462-2.775.381-5.49.5-8.166a15.2,15.2,0,0,0-.746-6.061,14.987,14.987,0,0,0-1.488-2.593,4.15,4.15,0,0,1,.927.235c5.546,2.5,6.717,7.648,5.659,12.917A47.262,47.262,0,0,1,21.426,98.6C21.1,99.633,20.306,101.018,20.569,102.059Z",
    transform: "translate(-11.346 -80.518)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.983 21.175)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.71,112.389H17.278l-3.749-11.965H32.459Z",
    transform: "translate(-12.763 -98.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M28.783,111.6H16.2l-.079-1.891H28.861Z",
    transform: "translate(-12.29 -96.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.909,102.206H13.252l-.371-3.776h20.4Z",
    transform: "translate(-12.881 -98.43)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M89.048,92.222l1.365,2.765A3.5,3.5,0,0,0,93.047,96.9l3.053.445a3.5,3.5,0,0,1,1.939,5.967l-2.208,2.153a3.5,3.5,0,0,0-1.006,3.1l.521,3.041a3.5,3.5,0,0,1-5.077,3.687l-2.731-1.435a3.5,3.5,0,0,0-3.256,0l-2.73,1.435a3.5,3.5,0,0,1-5.077-3.687L77,108.563a3.5,3.5,0,0,0-1.006-3.1l-2.21-2.153a3.5,3.5,0,0,1,1.939-5.967l3.054-.445a3.5,3.5,0,0,0,2.634-1.914l1.365-2.765A3.5,3.5,0,0,1,89.048,92.222Z",
    transform: "translate(10.542 -69.21)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 12.542,
    height: 46.204,
    transform: "translate(10.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 7.15,
    height: 40.168,
    transform: "translate(22.483 6.035)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 10.533,
    height: 29.979,
    transform: "translate(0 16.224)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 10.533,
    height: 3.477,
    transform: "translate(0 20.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 10.533,
    height: 3.477,
    transform: "translate(0 39.111)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 8.84,
    height: 42.804,
    transform: "translate(29.011 3.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 4.179,
    height: 19.176,
    transform: "translate(31.341 16.37)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 45.752)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.695 8.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.726 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.395,
    height: 17.96,
    transform: "translate(12.208 19.603) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.02,
    height: 5.165,
    transform: "translate(17.02 5.165) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.395,
    height: 17.96,
    transform: "translate(12.208 19.603) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.02,
    height: 5.165,
    transform: "translate(17.02 5.165) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 116.137,
    height: 9.708,
    transform: "translate(116.137 9.708) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.626)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-22.2,158.771h-7.539a.623.623,0,0,0-.593.43l-13.487,22.756a.783.783,0,0,0,.7,1.029h13.126a.624.624,0,0,0,.593-.43l7.9-22.757A.783.783,0,0,0-22.2,158.771Z",
    transform: "translate(43.863 -149.658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-37.96,151.063H1.732l5.354,33.378H-32.607Z",
    transform: "translate(44.938 -151.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-36.785,151.063H2.908l5.354,33.378H-31.431Z",
    transform: "translate(45.152 -151.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-33.717,153.67H-.289l4.365,27.214H-29.352Z",
    transform: "translate(45.711 -150.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-28.978,158.088h23.9l2.689,16.766h-23.9Z",
    transform: "translate(46.575 -149.782)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.4 10.746)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M28.948,171.277a11.1,11.1,0,0,1-5.958,9.848.894.894,0,0,1-.213.106,10.885,10.885,0,0,1-4.954,1.17,11.107,11.107,0,0,1-8.571-4.043,5.8,5.8,0,0,1-.461-.6A10.958,10.958,0,0,1,6.7,171.277a11.135,11.135,0,0,1,9.316-10.971c.177-.035.355-.059.532-.083a11.144,11.144,0,0,1,12.283,9.47c.035.225.059.449.083.674C28.936,170.662,28.948,170.969,28.948,171.277Z",
    transform: "translate(-6.698 -160.152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.514,171.987a20.349,20.349,0,0,1-3.925,4.67,9.243,9.243,0,0,1-2.66,1.691,5.8,5.8,0,0,1-.461-.6,11.817,11.817,0,0,0,3.629-2.636A18.969,18.969,0,0,0,15.786,170a11.336,11.336,0,0,0,1.052-6.479,9.036,9.036,0,0,0-.934-2.861,2.933,2.933,0,0,0-.213-.366c.177-.035.355-.059.532-.083.13.213.236.426.331.615C18.328,164.421,17.536,168.677,15.514,171.987Z",
    transform: "translate(-6.375 -160.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M26.434,168.9a12.584,12.584,0,0,0-1.371,1.147,15.328,15.328,0,0,0-4.552,9.612.893.893,0,0,1-.213.106,15.133,15.133,0,0,1,4.386-10.108,14.774,14.774,0,0,1,1.667-1.431C26.387,168.447,26.41,168.671,26.434,168.9Z",
    transform: "translate(-4.22 -158.681)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.695 8.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.726 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.395,
    height: 17.959,
    transform: "translate(12.208 19.603) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.02,
    height: 5.165,
    transform: "translate(17.02 5.165) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 7.395,
    height: 17.959,
    transform: "translate(12.208 19.603) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.02,
    height: 5.165,
    transform: "translate(17.02 5.165) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 116.136,
    height: 9.708,
    transform: "translate(116.136 9.708) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(471.25 312.045)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 27.661,
    cy: 26.273,
    rx: 27.661,
    ry: 26.273,
    transform: "translate(1.785 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M397.385,361.56h-53.34l2.65,74.177h48.039Z",
    transform: "translate(-341.071 -331.817)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 60.478,
    height: 9.518,
    transform: "translate(0 25.183)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.009 2.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M360.49,341.663a58.154,58.154,0,0,0-3.415,10.6,63.861,63.861,0,0,0-1.157,8.906h40.056a26.24,26.24,0,0,0-15.383-22.473c-3.309.747-6.664,1.349-10.011,1.893A78.724,78.724,0,0,1,360.49,341.663Z",
    transform: "translate(-355.917 -338.693)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.664 49.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 180.087,
    height: 119.137
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M155.852,148.34c-.09.442.442,29.043.442,29.043l15.4-28.9Z",
    transform: "translate(-121.863 -30.987)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.583 5.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 170.921,
    height: 108.715
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,0H170.92a0,0,0,0,1,0,0V106.718a0,0,0,0,1,0,0H2.957A2.957,2.957,0,0,1,0,103.761V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M0,0H159.582a0,0,0,0,1,0,0V94.49a0,0,0,0,1,0,0H1.716A1.716,1.716,0,0,1,0,92.774V0A0,0,0,0,1,0,0Z",
    transform: "translate(11.338)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(47.437 5.578)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M278.082,73.026c-1.934-1.7-5.773-1.17-8.317-1.229-7.652-.175-15.306-.263-22.962-.222a.75.75,0,0,0-.807.638q-.1,8.2.559,16.374a73.369,73.369,0,0,0-10.584-10.923c-.224-.181-.667.056-.464.282,3.849,4.291,7.835,8.453,11.268,12.987.342.451,1.365.338,1.321-.271-.425-5.917-.618-11.85-.513-17.777,6.071.048,12.144.11,18.214.222,3,.055,6.048,0,9.037.209,3.361.232,2.628,2.864,3.447,4.774a.533.533,0,0,0,.942.015A4.53,4.53,0,0,0,278.082,73.026Z",
    transform: "translate(-166.647 -52.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M272.15,81.984c-.937.893-2.119,2.9-3.918,2.454-1.034-.259-1.3-1.477-1.636-2.193q-.558-1.209-1.107-2.419a.731.731,0,0,0-1.2-.149,17.988,17.988,0,0,1-1.732,2.247c-.465.51-1.632,1.977-2.592,1.649-.758-.259-1.049-1.47-1.145-2.172a5.031,5.031,0,0,0,.588-3.2c-.076-.451-1-.577-1.233-.153a5.536,5.536,0,0,0-.709,3.194,9.44,9.44,0,0,1-4.1,3.671c-1.876.6-3.03-.918-3.477-2.2-.247-.7-.851-3.309.414-3.432.389-.038.278-.517-.076-.537l-.678-.041a.413.413,0,0,0-.348.157,5.077,5.077,0,0,0-.21,4.839,3.973,3.973,0,0,0,4.036,2.415c1.97-.232,3.483-1.7,4.591-2.943.089-.1.153-.206.237-.307a3.023,3.023,0,0,0,1.34,1.672c2.133,1.073,4.313-1.52,5.536-3.269.385.877.768,1.755,1.2,2.615a2.806,2.806,0,0,0,2.219,1.68,4.112,4.112,0,0,0,4.552-3.3A.332.332,0,0,0,272.15,81.984Z",
    transform: "translate(-161.913 -50.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M275.849,70.9a1.834,1.834,0,0,0-1.15-.331,5.025,5.025,0,0,1-1.215-.218c-.56-.185-1.122-.6-1.189-1.118-.033-.51-.987-.536-.976-.015,0,.037.019.07.022.106h-.007a4.272,4.272,0,0,1-.075,2.066,2.849,2.849,0,0,1-.524.95c-.194.232-.623.675-1,.675-.356,0-.432-.473-.472-.693a10.883,10.883,0,0,1-.146-1.47,13.17,13.17,0,0,1,.209-2.915c.034-.188-.363-.24-.408-.052a13.572,13.572,0,0,0-.36,2.745,12.983,12.983,0,0,0,.038,1.381,2.608,2.608,0,0,0,.211,1.008,1.022,1.022,0,0,0,.723.556,1.653,1.653,0,0,0,1.219-.371,3.311,3.311,0,0,0,1.235-1.636,5.208,5.208,0,0,0,.2-.865,3.229,3.229,0,0,0,.582.341,5.367,5.367,0,0,0,1.523.4,2.075,2.075,0,0,0,1.542-.18A.227.227,0,0,0,275.849,70.9Z",
    transform: "translate(-154.61 -53.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M238.7,104.16a1.821,1.821,0,0,1-1.969.194,3.274,3.274,0,0,1-1.327-1.834.73.73,0,0,0-1.2-.147l-1.827,2.189c-.271.325-1.617,2.176-1.811,1.05a13.531,13.531,0,0,1,.529-5.349c.161-.633-1.019-.925-1.182-.286a10.085,10.085,0,0,1-2.264,4.215c-.852.959-2.765,2.94-4.459,2.595-1-.206-1.167-1.226-1.312-1.936a9.958,9.958,0,0,1-.17-2.606A10.671,10.671,0,0,1,223.4,97.21c.262-.416-.488-.8-.764-.382a11.577,11.577,0,0,0-1.972,5.9c-.063,1.493-.115,4.226,1.939,4.908s4.189-1.062,5.379-2.208a12.222,12.222,0,0,0,1.3-1.5v.012c-.046.86-.345,2.355.649,2.941a2.184,2.184,0,0,0,2.6-.589c.754-.788,1.425-1.64,2.1-2.484a3.341,3.341,0,0,0,2.048,1.721c1.162.31,2.469-.05,2.8-1.083C239.6,104.05,238.978,103.837,238.7,104.16Z",
    transform: "translate(-172.034 -43.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M245.1,105.364a3.964,3.964,0,0,0-.888-.792l-1.021-.839c-.127-.1-.258-.2-.385-.31.1-.226.2-.449.293-.676A11.433,11.433,0,0,0,244,98.6c0-.344-.61-.348-.645-.011a11.394,11.394,0,0,1-1.327,3.978c-.027.052-.06.1-.087.157-.251-.2-.495-.406-.749-.6l-4.094-3.168c-.4-.308-.986.15-.614.485l3.836,3.462c.334.3.682.593,1.025.889-.112.2-.218.4-.331.593a15.826,15.826,0,0,0-1.064,2.036c-.222.582.841.99,1.207.44a15.978,15.978,0,0,0,1.055-2.04c.031-.067.056-.136.087-.2l.9.766a3.212,3.212,0,0,0,1.117.795C244.905,106.341,245.354,105.777,245.1,105.364Z",
    transform: "translate(-166.317 -42.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M275.453,99.444a.343.343,0,0,0-.6.124,3.251,3.251,0,0,1-2.39,2.735,2.52,2.52,0,0,1-3.1-2.276c.03-.727-1.355-.93-1.567-.2-.349,1.2-.908,3.174-2.756,3.285-2.641.155-3.033-2.625-2.847-4.166.075-.625-1.165-.784-1.334-.17a6.145,6.145,0,0,1-3.885,4.25c-3.114.983-3.5-2.258-3.369-4,.037-.577-1.11-.747-1.25-.158-.01.044-.011.094-.02.139h-.005c0,.014,0,.031,0,.044a5.618,5.618,0,0,0-.094,1.154,3.278,3.278,0,0,1-1.381,2.24c-.319.184-.905.353-1.15.183-.214-.149-.132-.783-.117-1.055a4.114,4.114,0,0,1,.821-2.163c.184-.259-.271-.479-.48-.24-.754.859-2.5,4.447-.025,4.628,1.068.078,2.02-.927,2.547-1.57.046-.057.075-.117.119-.175a3.329,3.329,0,0,0,3.579,2.34,6.478,6.478,0,0,0,4.807-2.877,3.866,3.866,0,0,0,3.607,2.873,3.954,3.954,0,0,0,3.956-2.255,4.436,4.436,0,0,0,4.042,1.557C274.863,103.371,276.744,101.225,275.453,99.444Z",
    transform: "translate(-161.859 -42.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M225.489,57.927a.613.613,0,0,0-.828-.292c-9.931,4.844-19.925,9.663-29.63,14.817a5.9,5.9,0,0,0-1.114-.706.386.386,0,0,0-.461.091.557.557,0,0,0-.008.7c.112.139.361.057.326-.106l.005-.019q.245.221.5.438c-.9.48-1.812.945-2.707,1.432-.241.132-.034.451.224.329.965-.462,1.921-.94,2.885-1.4a9.882,9.882,0,0,1,1.075,1.076,9.5,9.5,0,0,1,1.512,2.509,9.088,9.088,0,0,1,.556,1.844c-4.1-.259-8.191-.634-12.3-1.062a.434.434,0,1,0-.161.854c4.113.63,8.3,1.036,12.5,1.286a2.355,2.355,0,0,1-.92,1.717.185.185,0,0,0,.1.33c1.143.218,1.662-.8,1.8-1.56a3.769,3.769,0,0,0,.033-.432,177.406,177.406,0,0,0,29.06-.975.532.532,0,0,0,.458-.476A86.068,86.068,0,0,0,225.489,57.927ZM206.326,78.973c-2.513-.02-5.007-.131-7.5-.274a9.052,9.052,0,0,0-.428-1.6,10.067,10.067,0,0,0-1.706-2.985,11.977,11.977,0,0,0-1.21-1.293c9.678-4.683,19.266-9.483,29.037-14.038a97.188,97.188,0,0,1,2.629,19.1A174.239,174.239,0,0,1,206.326,78.973Z",
    transform: "translate(-184.995 -57.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M227.337,62.5a7.162,7.162,0,0,0-1.872.537c-.615.217-1.218.455-1.825.689a34.568,34.568,0,0,0-3.727,1.5c-.18.1-.08.352.146.3a34.973,34.973,0,0,0,3.773-1.28c.615-.22,1.234-.43,1.84-.667a6.938,6.938,0,0,0,1.79-.817A.153.153,0,0,0,227.337,62.5Z",
    transform: "translate(-172.332 -55.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M230.783,61a2.508,2.508,0,0,0-1.448-.079l-1.86.195-1.86.195c-.31.033-.618.061-.923.117a3.184,3.184,0,0,0-.965.225c-.207.116-.175.345.057.421a2.306,2.306,0,0,0,.739.048c.269,0,.532,0,.8-.022l1.6-.123,1.6-.123c.491-.038,1.006-.119,1.5-.11h.016a4.1,4.1,0,0,1-.245.473,9.845,9.845,0,0,1-.656.994,10.463,10.463,0,0,1-.753.889c-.14.149-.293.289-.428.442a2.566,2.566,0,0,0-.326.528c-.147.273.29.473.558.365a3.265,3.265,0,0,0,1.226-.929,10.149,10.149,0,0,0,.915-1.14,9.9,9.9,0,0,0,.713-1.21A.8.8,0,0,0,230.783,61Z",
    transform: "translate(-170.962 -56.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M255.124,59.912c-.475-.08-.96-.128-1.429-.222-.522-.1-.937-.329-1.436-.466a1.986,1.986,0,0,0-1.6.2,8.333,8.333,0,0,0-1.263,1.235c-1.08.99-2.07-.139-2.565-1a.593.593,0,0,0-1.042.214c-.067.751-1.132,1-1.818.671a1.638,1.638,0,0,1-.945-1.484c-.015-.434-.7-.614-.993-.237a11.689,11.689,0,0,1-2.415,2.347,1.157,1.157,0,0,1-1.784-.536,2.048,2.048,0,0,1,.049-1.706c.184-.532-.746-.738-.986-.24a4.5,4.5,0,0,1-1.8,2.374c-.649.442-1.874.765-2.381.031a3.193,3.193,0,0,1-.337-1.985c.01-.07-.117-.079-.142-.018-.325.806-.8,1.5-.3,2.362a2.058,2.058,0,0,0,1.931.946,4.344,4.344,0,0,0,2.857-1.556,2.172,2.172,0,0,0,1.812,1.615c1.467.251,2.828-1.148,3.739-2.294a2.536,2.536,0,0,0,4.158.7c.888,1,2.224,1.75,3.581.66.683-.55,1.034-1.677,2.148-1.3a3.613,3.613,0,0,0,3.026.146A.244.244,0,0,0,255.124,59.912Z",
    transform: "translate(-168.004 -57.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M255.029,64.073c-.879-.213-1.846-.052-2.763-.229a27.092,27.092,0,0,0-2.855-.517,5.03,5.03,0,0,0-2.595.434c-.495.235-2.435,1.5-2.715.443-.1-.371-.663-.462-.982-.229a5.057,5.057,0,0,1-3.27,1.3c-1.134-.083-2.182-1.2-1.046-1.924.435-.275-.128-.91-.577-.64a1.717,1.717,0,0,0,.292,3.136c1.684.806,3.453.1,4.845-.784a2.416,2.416,0,0,0,1.736.511c1.313-.091,2.154-1.122,3.462-1.227a15.217,15.217,0,0,1,3.7.559c.983.166,2.309.357,2.966-.415C255.352,64.339,255.231,64.121,255.029,64.073Z",
    transform: "translate(-165.965 -55.735)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.053 387.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M98.691,338.161c1.449,0,2.461.227,3.295,1.531a5.794,5.794,0,0,1,.8,2.6c.071.763-.17,1.776.471,2.234a6.333,6.333,0,0,0,3.979.569c2.016-.279,2.983-1.3,2.2-3.239a8.185,8.185,0,0,0-4.028-4.205,11.382,11.382,0,0,0-4.417-1.3,2.375,2.375,0,0,0-1.717.608C99.026,337.168,98.3,337.83,98.691,338.161Z",
    transform: "translate(-52.687 -335.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M87.845,356.5c-3.233-1.058-8.95,10.841-10.333,12.81a84.382,84.382,0,0,0-11.73,25.332c-3.492,12.121-7.118,24.334-5.71,37.083.913,8.254,6.132,14.266,15.023,13.331,4.217-.443,12.4-1.121,15.886-3.543,1.59-1.105,1.7-2.548.32-4.507-1.4-2-2.419-1.582-4.821-1.105-4.535.9-8.447,2.115-12.358-1.4-3.847-3.452-4.258-9.532-4.052-14.414a95.912,95.912,0,0,1,3.594-21.067c2.374-8.766,5.942-16.69,9.227-25.1,1.455-3.723,3.551-7.644,4.386-11.553.5-2.334-.035-4.187.794-6.358C87.68,355.962,87.2,355.914,87.845,356.5Z",
    transform: "translate(-59.761 -331.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M71.324,438.757a16.881,16.881,0,0,1-4.339-6.248c-2.227-5.307-2.55-11.31-2.372-17A142.011,142.011,0,0,1,66.781,396.7c.868-5.209,1.908-10.394,3.269-15.5q.768-2.885,1.712-5.7a93.342,93.342,0,0,0-5.98,15.588c-3.492,12.121-7.118,24.334-5.71,37.082.913,8.256,6.132,14.267,15.023,13.332q.4-.043.839-.086A13.966,13.966,0,0,1,71.324,438.757Z",
    transform: "translate(-59.761 -328.003)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.722 7.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M146.3,443.894c-2.166,2.1-18.424,4.664-33.5,5.43-3.148.15-6.214.233-9.111.216-7.147-.033-16.042.233-18.524-1.782-5.914-4.781-20.405-86.472,4.631-100.832,5.731-3.282,19.34-5.181,24.6-4.948.632.034,1.25.067,1.849.15,16.558,1.933,25.853,20.506,29.884,47.658C151.562,426.27,150.047,440.279,146.3,443.894Z",
    transform: "translate(-75.597 -341.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M112.8,449.321c-3.145.154-6.219.236-9.115.225-7.141-.036-16.043.225-18.526-1.785-5.911-4.788-20.405-86.469,4.634-100.833,2.542-1.454,6.621-2.636,10.841-3.488,2.081-.414,4.209-.757,6.183-.993a51.313,51.313,0,0,1,7.578-.473c.638.036,1.253.071,1.856.154-6.408.615-11.562,5.166-14,12.945C95.02,378.21,102.338,421.019,112.8,449.321Z",
    transform: "translate(-75.597 -341.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M105.3,342.372a24.526,24.526,0,0,0-6.372,4.918c-4.031,4.445-6.774,10.2-8.595,15.889a73.408,73.408,0,0,0-3.168,17.663c-.426,6.349.26,12.626.65,18.963.437,7.117,1.714,14.009,2.424,21.091.047.52-1.525.946-1.986.674-.532.13-1.1.13-1.17-.142a99.424,99.424,0,0,1-1.832-12.413c-.485-4.043-.863-8.11-1.088-12.177-.686-12.449-.272-25.406,4.232-37.181,2.175-5.687,5.3-11.6,9.943-15.641.26-.225.508-.437.78-.65C101.2,342.951,103.33,342.608,105.3,342.372Z",
    transform: "translate(-74.083 -341.883)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M130.373,367.917a4.366,4.366,0,0,0-1.244-2.7,5.327,5.327,0,0,0-3.295-.648q-4.958.032-10.372.534a32.715,32.715,0,0,0-4.951.623c-.363.091-2.194.054-2.788,1.094-.283.493-.114,2.6,0,4.412.129,2.038.27,3.781,1.206,4.122.4,0,.76.16,1.147.183a9.3,9.3,0,0,0,1.371-.128q1.415-.135,2.8-.275,2.662-.27,5.207-.563,4.877-.559,9.353-1.166a1.9,1.9,0,0,0,1.717-1.1,3.871,3.871,0,0,0,.157-1.55A23.325,23.325,0,0,0,130.373,367.917Z",
    transform: "translate(-51.048 -329.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M92.845,346.948c-1.206.066-.189-6.9.856-8.3,1.721-2.311,4.77-3.011,7.5-3.3,3.146-.332,9.522,2.917,9.437,6.954-1.854-3.346-7.735-6.96-10.962-3.03-1.406,1.712.052,4.384-.88,5.788C97.588,346.873,94.051,346.882,92.845,346.948Z",
    transform: "translate(-53.831 -335.324)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.117 54.673)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M148.872,438.175c-1.9,1.432-18.457,4.2-29.418,4.414-3.932.083-7.147-.167-8.712-.916-3.449-1.616-5.6-17.025-5.147-32.783.332-11.66,4.048-21.855,11.261-25.12a23.145,23.145,0,0,1,9.461-2.2,19.082,19.082,0,0,1,3.8.35c10.762,2.049,18.757,13.026,20.473,27.219C152.937,428.729,151.471,436.242,148.872,438.175Z",
    transform: "translate(-105.536 -381.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130.115,381.921a11.4,11.4,0,0,0-8.062,4.88c-3.965,7.213-5.048,16.225-5.3,24.6-.3,9.661-.033,21.355,2.7,31.184-3.932.083-7.147-.167-8.712-.916-3.449-1.616-5.6-17.025-5.147-32.783.332-11.66,4.048-21.855,11.261-25.12a23.145,23.145,0,0,1,9.461-2.2A19.082,19.082,0,0,1,130.115,381.921Z",
    transform: "translate(-105.536 -381.57)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M88.107,408.15c1.958-.026,2.752,6.221,2.3,6.824s-2.93.813-3.557.377S86.151,408.175,88.107,408.15Z",
    transform: "translate(-54.896 -322.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.615 160.798)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.983 59.729)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 150.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.663,453.407h-4.417l14.923-132.152h12.288Z",
    transform: "translate(-208.247 -321.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.866,453.407h4.417L329.359,321.255H317.071Z",
    transform: "translate(-188.415 -321.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.771,453.407h4.417L303.265,321.255H290.977Z",
    transform: "translate(-193.17 -321.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.384,453.407h-4.417L247.89,321.255h12.288Z",
    transform: "translate(-203.742 -321.255)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M359.953,194.1l-23.321,135.33h-54.6L305.348,194.1Z",
    transform: "translate(-194.801 -194.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M353.29,194.1l-23.321,135.33H282.027L305.348,194.1Z",
    transform: "translate(-194.801 -194.099)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 128.997,
    height: 18.217,
    transform: "translate(12.834 135.331)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 46.313,
    height: 18.217,
    transform: "translate(12.834 135.331)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 250.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M191.442,364.052s-23.329,4.62-17.882,10.047,36.477,10.619,37.972,8.547,6.1-17.459,6.1-17.459l-21.543-9.731Z",
    transform: "translate(-172.735 -355.456)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M200.947,375.755c2.713-2.038,5.65-4.05,9.019-4.446.617-.073,1.368-.026,1.682.511a1.543,1.543,0,0,1,.13.934,10.515,10.515,0,0,1-2.192,4.9,17.131,17.131,0,0,1-3.751,4.033,8.178,8.178,0,0,1-5.151,1.7c-1.384-.073-4.627-1.188-4.529-3.021C196.242,378.741,199.766,376.641,200.947,375.755Z",
    transform: "translate(-168.467 -352.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M183.438,375c.118,1.669-.033,3.581-1.336,4.633-1.388,1.12-3.457.74-5.066-.03a11.116,11.116,0,0,1-5.224-4.994,8.488,8.488,0,0,1-.239-7.123,11.2,11.2,0,0,1,1.5-2.337,8.349,8.349,0,0,1,2.8-2.454c1-.478,2.673-.75,3.53.122a13.356,13.356,0,0,1,1.894,3.609A25.739,25.739,0,0,1,183.438,375Z",
    transform: "translate(-173.069 -354.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M187.057,378.633a50.079,50.079,0,0,0,13.112,1.114c2.278-.064,4.935-.513,5.587-2.77.5-1.738-.459-3.8-1.588-5.458a23.28,23.28,0,0,0-7.08-6.77,28.035,28.035,0,0,1-3.4-2.14,5.622,5.622,0,0,1-2.146-3.426,3.634,3.634,0,0,1,1.55-3.389,7.691,7.691,0,0,1,3.55-1.123,22.66,22.66,0,0,1,16.81,4.419c4.987,3.938,8.277,11.005,6.823,16.723a14,14,0,0,1-5.074,7.318,24.728,24.728,0,0,1-20.213,4.717,33.039,33.039,0,0,1-14.43-6.936c-2.031-1.652-6.829-4.772-8.278-7.059-2.189-3.456,3.361.571,4.479,1.254C179.679,376.89,183.905,377.88,187.057,378.633Z",
    transform: "translate(-172.91 -355.633)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.78 262.859)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.935,375.656s-19.52,13.585-12.356,16.373,37.675-4.894,38.215-7.393-1.41-18.44-1.41-18.44l-23.636-.278Z",
    transform: "translate(-202.999 -365.918)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M230.811,382.033c1.668-2.954,3.551-5.975,6.48-7.689a1.66,1.66,0,0,1,1.747-.207,1.552,1.552,0,0,1,.493.8,10.509,10.509,0,0,1-.044,5.37,17.11,17.11,0,0,1-1.819,5.2,8.176,8.176,0,0,1-4.037,3.622c-1.3.489-4.715.767-5.36-.951C227.7,386.654,230.084,383.319,230.811,382.033Z",
    transform: "translate(-198.41 -364.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M214.6,387.912c.778,1.483,1.406,3.295.634,4.78-.823,1.583-2.87,2.065-4.653,2a11.112,11.112,0,0,1-6.787-2.48,8.484,8.484,0,0,1-3.075-6.429,11.214,11.214,0,0,1,.436-2.743,8.331,8.331,0,0,1,1.585-3.372c.726-.839,2.148-1.758,3.282-1.3a13.3,13.3,0,0,1,3.181,2.548A25.751,25.751,0,0,1,214.6,387.912Z",
    transform: "translate(-203.416 -363.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M218.665,391.358a50.05,50.05,0,0,0,12.46-4.237c2.062-.971,4.315-2.447,4.009-4.777-.236-1.793-1.946-3.3-3.642-4.365a23.3,23.3,0,0,0-9.2-3.362,28.206,28.206,0,0,1-3.975-.6,5.624,5.624,0,0,1-3.339-2.279,3.631,3.631,0,0,1,.06-3.726,7.684,7.684,0,0,1,2.8-2.452,22.659,22.659,0,0,1,17.173-2.691c6.146,1.609,11.994,6.764,12.954,12.585a14.006,14.006,0,0,1-1.715,8.739,24.725,24.725,0,0,1-16.626,12.424,33.033,33.033,0,0,1-16-.57c-2.523-.7-8.169-1.634-10.414-3.148-3.391-2.288,3.309-.824,4.607-.647C211.208,392.719,215.477,391.932,218.665,391.358Z",
    transform: "translate(-203.134 -366.595)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.533 159.288)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M324.419,278.577s6.756,32-12.734,32.506-71.984,2.539-71.984,2.539l-24.859,72.537-29.777-10.808s21.372-80.014,29.429-86.616,59.25-10.665,69.125-10.412S324.419,278.577,324.419,278.577Z",
    transform: "translate(-184.02 -278.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M324.419,278.577s6.756,32-12.734,32.506-71.984,2.539-71.984,2.539l-24.859,72.537-29.777-10.808s21.372-80.014,29.429-86.616,59.25-10.665,69.125-10.412S324.419,278.577,324.419,278.577Z",
    transform: "translate(-184.02 -278.312)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 87.796)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M184.182,363.37l30.3,10.7,5.1-9.231-33.345-12.264Z",
    transform: "translate(-184.182 -352.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M184.182,363.37l30.3,10.7,5.1-9.231-33.345-12.264Z",
    transform: "translate(-184.182 -352.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M198.627,365.505a41.115,41.115,0,0,1-6.683-7.468,30.054,30.054,0,0,1-2.491-4.279l-3.219-1.185-2.051,10.8,23.438,8.276A44.277,44.277,0,0,1,198.627,365.505Z",
    transform: "translate(-184.182 -352.574)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.898 160.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M336.616,279.652s7.012,33.979-13.214,34.519-74.7,2.7-74.7,2.7L242.97,390.1l-30.6-1.075s1.81-91.571,10.171-98.583,61.484-11.326,71.732-11.056S336.616,279.652,336.616,279.652Z",
    transform: "translate(-212.374 -279.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M234.914,388.515a33.334,33.334,0,0,1-2.255-6.852c-.586-2.44-1.15-4.9-1.669-7.35a141.221,141.221,0,0,1-2.375-17.652c-.426-5.157-.78-10.319-1.235-15.474-.434-4.907-.835-9.823-.894-14.751-.115-9.573,1.075-19.418,6.633-27.477a60.677,60.677,0,0,1,17.251-16.381c-12.847,1.855-24.307,4.327-27.826,7.278-8.361,7.012-10.171,98.583-10.171,98.583l22.955.806C235.19,389,235.037,388.765,234.914,388.515Z",
    transform: "translate(-212.374 -278.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M330.92,279.61s-2.9,0-7.216-.007c-.015.489-.035.978-.066,1.465a44.133,44.133,0,0,1-.848,6.3,23.279,23.279,0,0,1-1.775,5.736c-1.825,3.612-5.237,6.239-8.582,8.366a59.889,59.889,0,0,1-11.25,5.581c-8.407,3.134-17.345,4.686-26.23,5.694-5.957.675-11.935.959-17.9,1.477-2.918.253-5.844.551-8.727,1.071a22.927,22.927,0,0,0-3.256.778,3.5,3.5,0,0,0-1.434.734c6.091-.241,55.12-2.167,74.074-2.672C337.932,313.589,330.92,279.61,330.92,279.61Z",
    transform: "translate(-206.678 -279.329)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.576 7.423)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M231.766,363.095h-.021a.3.3,0,0,1-.273-.314l.129-1.767a.273.273,0,0,1,.317-.272.294.294,0,0,1,.272.317l-.129,1.764A.3.3,0,0,1,231.766,363.095Z",
    transform: "translate(-231.47 -360.735)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.396 4.541)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M232.1,370.716h-.022a.3.3,0,0,1-.272-.317l.272-3.608a.281.281,0,0,1,.317-.273.294.294,0,0,1,.272.317l-.272,3.609A.3.3,0,0,1,232.1,370.716Zm.547-7.218h-.024a.3.3,0,0,1-.271-.318l.28-3.608a.275.275,0,0,1,.318-.271.3.3,0,0,1,.271.317l-.28,3.608A.3.3,0,0,1,232.648,363.5Zm.562-7.213h-.022a.3.3,0,0,1-.272-.318q.138-1.761.287-3.606a.3.3,0,1,1,.589.048q-.149,1.839-.287,3.6A.294.294,0,0,1,233.209,356.286Zm.579-7.213h-.024a.294.294,0,0,1-.271-.318l.3-3.6a.288.288,0,0,1,.319-.27.294.294,0,0,1,.271.318l-.3,3.6A.3.3,0,0,1,233.789,349.073Zm.6-7.206h-.024a.3.3,0,0,1-.271-.319l.306-3.6a.281.281,0,0,1,.32-.268.3.3,0,0,1,.268.319l-.306,3.6A.3.3,0,0,1,234.386,341.868Zm.618-7.206h-.026a.3.3,0,0,1-.268-.32l.319-3.6a.279.279,0,0,1,.322-.268.3.3,0,0,1,.267.322l-.319,3.6A.3.3,0,0,1,235,334.662Zm.65-7.2h-.028a.3.3,0,0,1-.266-.322q.168-1.828.338-3.6a.284.284,0,0,1,.322-.267.3.3,0,0,1,.267.323q-.168,1.77-.338,3.6A.3.3,0,0,1,235.654,327.457Zm.689-7.2h-.03a.3.3,0,0,1-.265-.323q.184-1.858.366-3.6a.305.305,0,0,1,.326-.264.3.3,0,0,1,.262.326c-.121,1.157-.244,2.36-.366,3.6A.3.3,0,0,1,236.344,320.256Zm.755-7.2h-.032a.3.3,0,0,1-.261-.327c.143-1.279.284-2.482.422-3.6a.3.3,0,0,1,.329-.258.3.3,0,0,1,.258.33c-.137,1.111-.279,2.315-.422,3.59A.294.294,0,0,1,237.1,313.06Zm.9-7.181a.268.268,0,0,1-.043,0,.293.293,0,0,1-.249-.335c.228-1.565.441-2.775.633-3.593a.295.295,0,0,1,.575.134c-.187.8-.4,2-.623,3.544A.3.3,0,0,1,238,305.879Zm3.316-5.263a.3.3,0,0,1-.038-.589c.925-.117,2.108-.239,3.619-.371a.292.292,0,0,1,.32.268.3.3,0,0,1-.27.32c-1.5.132-2.679.253-3.6.369Zm7.219-.659a.3.3,0,0,1-.021-.591c1.131-.084,2.341-.169,3.615-.255a.282.282,0,0,1,.314.274.3.3,0,0,1-.275.315c-1.272.086-2.479.171-3.611.257Zm7.226-.494a.3.3,0,0,1-.018-.59c1.169-.074,2.376-.15,3.612-.226a.286.286,0,0,1,.314.277.3.3,0,0,1-.277.314l-3.613.223Zm7.227-.442a.3.3,0,0,1-.018-.591l3.613-.213a.3.3,0,0,1,.034.591l-3.613.213Zm7.225-.421a.3.3,0,0,1-.018-.591l3.611-.208a.3.3,0,1,1,.034.591l-3.609.208Zm7.222-.416a.3.3,0,0,1-.017-.591l3.612-.21a.3.3,0,1,1,.035.591l-3.613.21Zm7.225-.427a.3.3,0,0,1-.018-.591c1.225-.073,2.432-.148,3.612-.22a.281.281,0,0,1,.313.275.3.3,0,0,1-.277.313q-1.77.112-3.614.222Zm7.226-.452a.3.3,0,0,1-.019-.59c1.247-.082,2.456-.163,3.611-.244a.285.285,0,0,1,.316.274.294.294,0,0,1-.274.314c-1.157.08-2.366.162-3.613.244Zm7.225-.51a.3.3,0,0,1-.022-.59c1.306-.1,2.516-.2,3.607-.3a.282.282,0,0,1,.32.267.3.3,0,0,1-.267.322c-1.094.1-2.305.2-3.614.3Zm7.215-.681a.3.3,0,0,1-.037-.59,9.337,9.337,0,0,0,2.543-.494c.24-.145.489-.3.746-.476a.3.3,0,1,1,.33.489c-.265.18-.523.343-.771.492a8.458,8.458,0,0,1-2.775.577Zm6.213-3.3a.295.295,0,0,1-.206-.507,18.6,18.6,0,0,0,2.31-2.691.3.3,0,0,1,.485.338,19.093,19.093,0,0,1-2.383,2.777A.3.3,0,0,1,312.537,292.815Z",
    transform: "translate(-231.805 -289.491)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.724)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M303.431,287.939a.287.287,0,0,1-.108-.021.3.3,0,0,1-.168-.382,10.254,10.254,0,0,0,.5-1.652.3.3,0,0,1,.35-.229.3.3,0,0,1,.231.35,11.013,11.013,0,0,1-.526,1.746A.3.3,0,0,1,303.431,287.939Z",
    transform: "translate(-303.135 -285.65)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 99.681)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M212.046,374.595l32.117.962,2.045-10.345-35.5-1.525Z",
    transform: "translate(-210.712 -363.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M226.455,372.229a41.03,41.03,0,0,1-8.64-5.078,29.993,29.993,0,0,1-3.676-3.317l-3.427-.147,1.334,10.907,24.845.745A44.3,44.3,0,0,1,226.455,372.229Z",
    transform: "translate(-210.712 -363.687)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.405 93.186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M269.611,222.4s-20.832,23.557-23.9,24.542-35.387,6.474-35.387,6.474L208.6,263.764s39.193,3.834,43.678,1.153,31-25.08,31-25.08Z",
    transform: "translate(-208.603 -222.399)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M247.973,237.177S265.255,210,272.825,208.03s21.98,3.841,13.909,18.925a131.169,131.169,0,0,1-18.366,25.859S252.844,250.918,247.973,237.177Z",
    transform: "translate(-159.024 -131.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M274.254,207.665a69.311,69.311,0,0,0-5.5,8.762c-2.039,3.757-3.847,7.637-5.6,11.535a129.936,129.936,0,0,0-4.793,12.11A79.642,79.642,0,0,0,256,248.744a29.8,29.8,0,0,0,10.907,4.069,131.17,131.17,0,0,0,18.366-25.859C292.4,213.634,282,207.551,274.254,207.665Z",
    transform: "translate(-157.561 -131.898)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.428 71.974)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.823,255.593c-2.151-31.634-3.6-39.5-7.3-44.133-3.667-4.589-17.2-6.6-26.723-6.969s-23.431,2.318-27.388,5.03-6.342,14.248-5.729,28.589c.531,12.422,3.145,25.624,3.039,31.373-.194,10.673-2.29,14.789-3.813,22.731,11.907,8.287,58,12.73,67.887,10.746C330.772,292.167,330.863,270.908,329.823,255.593Z",
    transform: "translate(-261.912 -204.457)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M280.993,213.184a4.755,4.755,0,0,0,1.273,4.052,7.942,7.942,0,0,0,3.858,1.994c2.713.746,8.842-.056,11.6-3.145,4.588,10.9,9.889,22.5,20.6,28.35a27.6,27.6,0,0,0,9.485,3.43,12.88,12.88,0,0,0,9.477-2.129c3.063-2.346,4.449-6.364,4.448-10.306s-1.226-7.819-2.626-11.553c-2.4-6.4-5.467-12.734-10.458-17.372-7.519-6.988-18.173-9.033-28.007-9.366-8.271-.279-16.524.449-24.094,3.121-7.476,2.639-14.314,7.291-18.783,13.869-5.783,8.512-7.213,20.2-3.683,30.344a3.5,3.5,0,0,0,1.954-.112c5.289-3.328,7.973-9.719,11.27-15.269A62.126,62.126,0,0,1,280.993,213.184Z",
    transform: "translate(-263.688 -205.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M308.421,282.945c-1.389,4.306-2.966,8.756-6.21,11.908-5.436,5.279-14.041,5.575-20.36,9.758,1.64,4.6,7.084,6.409,11.851,7.491,9.4,2.135,19.431,3.782,28.53.584,3.073-1.081,6.066-2.8,7.843-5.528a18.409,18.409,0,0,0,2.331-7.28c2.005-12.72,1.428-25.69.7-38.546q-1.154-20.259-2.852-40.48c-.326-3.838-.733-7.856-2.881-11.051a11.454,11.454,0,0,0-5.442-4.308c-3.406-1.247-2.8,1.273-2.6,3.9a143.655,143.655,0,0,1,.183,18.147,192.124,192.124,0,0,1-5.432,35.521C312.449,269.756,310.536,276.384,308.421,282.945Z",
    transform: "translate(-258.279 -204.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M288.726,291.779A109.758,109.758,0,0,1,274.2,285.81c-2.2-1.169-4.456-2.534-5.486-4.6a33.984,33.984,0,0,1,7.883.247l12.724,1.4c-4.466-1.5-8.647-3.975-12.7-6.281-2.042-1.161-7.751-3.518-6.1-6.788.56-1.112,1.827-1.617,2.8-2.286a2.34,2.34,0,0,0,.682-3.4c-.966-1.732-2.847-2.844-4.461-3.893a31.268,31.268,0,0,1-4.955-3.953,30.255,30.255,0,0,1-2.451-2.691c-.332,2.613.252,5.34.135,8a44.037,44.037,0,0,1-1.564,7.888,46.238,46.238,0,0,0-.592,17.951,6.87,6.87,0,0,0,1.094,3.1,8.038,8.038,0,0,0,3.352,2.25c6.594,2.823,14.064,3.645,21.394,4.238C290.363,297.35,293.655,293.561,288.726,291.779Z",
    transform: "translate(-262.351 -195.508)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.063 76.328)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M220.312,248.39a17.825,17.825,0,0,1,6.623-7.664,10.614,10.614,0,0,1,2.892-1.494,13.343,13.343,0,0,1,6.584.125,55.192,55.192,0,0,1,7.287,2.549q3.339,1.273,6.665,2.571a8.184,8.184,0,0,0,1.688.669c4.539.588,32.82,4.234,37.9,4.4,5.2-5.509,13.1-20.216,13.1-20.216s14.084,1.719,18.313,9.842c.048-.22-17.1,24.3-19.656,25.642s-14.122-.575-28.11-4.2c-10.586-2.744-19.737-5.6-23.564-6.822a9.828,9.828,0,0,1-1.879.3c-7.4.515-6.279-3.69-6.635-3.937l.189-.245c-1.429.5-2.868.981-4.323,1.4-.588.171-1.37.274-1.622-.192-.2-.363.091-.817.376-1.174a30.105,30.105,0,0,1,3.148-3.373l-7.175,4.771c-.475.317-1.129.643-1.564.356s-.246-.919,0-1.392a17.59,17.59,0,0,1,5.207-5.979q-2.415,1.823-4.832,3.644c-1.105.833-2.213,1.668-3.392,2.413-1.059.669-2.386,1.29-3.507.906a.491.491,0,0,1-.338-.264.559.559,0,0,1,.091-.395c1.384-2.682,3.835-4.855,6.226-6.953l-6.4,4.91c-.824.631-1.849,1.312-2.823,1.077a.852.852,0,0,1-.521-.316A1.075,1.075,0,0,1,220.312,248.39Z",
    transform: "translate(-220.156 -229.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M287.023,248.958A18.85,18.85,0,0,1,283.5,242.8c4.117-6.223,8-13.464,8-13.464s14.084,1.719,18.313,9.842c.032-.142-7.158,10.1-12.919,17.7C292.922,255.509,289.323,251.622,287.023,248.958Z",
    transform: "translate(-208.613 -229.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M238.926,245.783a42.632,42.632,0,0,1,4.91,1.328c1.6.384,3.282.53,4.916.819a92.938,92.938,0,0,1,12.71,3.676,234.546,234.546,0,0,0,23.962,6.507c4.951,1.063,10.19,2.477,15.434,2.15a8.278,8.278,0,0,1-1.63,1.555c-2.554,1.343-14.122-.575-28.11-4.2-10.586-2.744-19.737-5.6-23.564-6.821a9.829,9.829,0,0,1-1.879.3c-7.4.515-6.279-3.69-6.635-3.937l.189-.245c-1.429.5-2.868.981-4.323,1.4a2.574,2.574,0,0,1-1.173.112A57.513,57.513,0,0,1,238.926,245.783Z",
    transform: "translate(-217.682 -226.334)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M281.865,244.5c1.312-1.823,11.839-18.289,15.455-24.419,1.9-3.233,4.037-6.5,7.208-8.925,2.249-1.728,8.59-5.632,13.158-.332.241.279.471.575.689.87a11.853,11.853,0,0,1,.657,1.039c3.031,5.254,2.14,12.455.343,18.526a30.119,30.119,0,0,1-1.278,3.5,113.714,113.714,0,0,1-13.74,23.234C297.348,257.472,285.369,251.144,281.865,244.5Z",
    transform: "translate(-281.865 -208.139)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.429 21.884)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M316.459,228.283c-1.35,1.8-2.745,3.574-4.2,5.293-2.451,2.9-5.107,5.631-7.79,8.313-2.632,2.63-5.338,5.191-8.167,7.611-.993.85-2.011,1.674-3.041,2.484a28.187,28.187,0,0,0,9.019,2.633,113.712,113.712,0,0,0,13.74-23.234,30.118,30.118,0,0,0,1.278-3.5c.121-.405.235-.817.346-1.231C317.252,227.2,316.862,227.744,316.459,228.283Z",
    transform: "translate(-293.262 -226.65)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.361 60.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M277.926,197.372l16.231-2.348,1.775,13.377a3.48,3.48,0,0,1-.784,2.7,13.893,13.893,0,0,1-9.182,5c-4.978.582-5.607-1.7-5.538-3.125a17.166,17.166,0,0,0-.345-3.95Z",
    transform: "translate(-277.926 -195.024)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M275.937,206.85c13.394.508,19.137-12.369,18.755-12.912-.474-.675-1.757-.636-2.8-.46-7.319,1.241-17.524,4.569-18.685,7.3S274.047,206.778,275.937,206.85Z",
    transform: "translate(-278.848 -195.326)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.723,185.34a3.868,3.868,0,0,1-2.526-.707,7.417,7.417,0,0,1-1.1-2.233c-1.183-2.327-3.842-3.572-6.24-1.932-5.878,4.016-3.108,10.828-2.575,11.9a7.208,7.208,0,0,0,4.06,3.5c.562.171,1.613.382,1.769-.415.092-.472-.453-.917-.52-1.342a9.64,9.64,0,0,0,3.354,1c1.448.044,3.875-.368,4.6-1.763.766-1.465-.706-2.1-1.808-2.7,1.882.071,3.722-2.446,4.391-3.877C307.992,184.941,304.884,185.391,303.723,185.34Z",
    transform: "translate(-248.355 -136.99)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.199 16.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.287,159.394a8.568,8.568,0,0,0-1.055,3.083,25.84,25.84,0,0,0-.163,8.252,8.639,8.639,0,0,0,1.084,3.44,9.276,9.276,0,0,0,4.03,3.126,4.051,4.051,0,0,0,3.111.484,3.047,3.047,0,0,0,1.486-1.461c1.162-2.152.822-4.735.439-7.13a26.588,26.588,0,0,0-1.714-6.755,10.378,10.378,0,0,0-3.218-4.156C259.7,157.114,258.3,157.8,257.287,159.394Z",
    transform: "translate(-255.814 -157.694)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.04 7.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M282.393,210.657c-9.7,2.341-14.955,0-17.8-3.28-.218-.244-.41-.5-.6-.754-2.668-3.661-4.853-11.845-5.481-14.974-.048-.266-.1-.533-.157-.811a.22.22,0,0,0-.012-.092,69.038,69.038,0,0,1-.917-14.453c.785-21.638,18.951-30.969,34.39-23.841a29.5,29.5,0,0,1,13.773,13.816q.344.7.651,1.426C315.455,189.4,300.825,206.241,282.393,210.657Z",
    transform: "translate(-257.371 -150.093)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ag",
    transform: "translate(0.977 35.886)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M266.285,199.891a3.641,3.641,0,0,1-1.847,1.206c-.218-.244-.41-.5-.6-.754-2.668-3.661-4.853-11.845-5.481-14.974-.048-.266-.1-.533-.157-.811a6.237,6.237,0,0,1,3.308,1.75,16.662,16.662,0,0,1,5.371,10.42A4.316,4.316,0,0,1,266.285,199.891Z",
    transform: "translate(-258.197 -179.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M290.892,197.052c.227-.171.443-.348.65-.526,3.447-2.983,7.351-9.117,3.849-13.722a6.616,6.616,0,0,0-7.513-1.913,11.2,11.2,0,0,0-5.707,5.757,11.988,11.988,0,0,0-1.377,6.138,7.125,7.125,0,0,0,2.959,5.436C286.077,199.721,288.863,198.586,290.892,197.052Z",
    transform: "translate(-254.084 -180.447)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M316.049,173.652a54.113,54.113,0,0,1-1.173,5.438c-.188.669-.969,4.866-1.565,5.062a2.073,2.073,0,0,1-.765.115,2.389,2.389,0,0,1-1.462-.751c-.817-.785-1.582-1.8-2.908-1.6-1.906.245-3.334,4.556-5.273,4.621-2.365.082-3.3-2.188-3.981-4.41a62.8,62.8,0,0,1,.545-8.442,4.357,4.357,0,0,0,.051-.441,4.242,4.242,0,0,0-.341-.523c-1.462-2.042-3.912-2.792-6.072-3.887a19.267,19.267,0,0,1-3.758-2.891,12.408,12.408,0,0,1-3.334-4.229,41.349,41.349,0,0,1-1.616-5.079,31.794,31.794,0,0,1-10.732,8.263,51.335,51.335,0,0,1-9.064,3.348c-2.4.588-6.124,1.208-8.181-.523-1.888-1.584-1.8-3.952-1.344-6.174.7-3.347,3.028-5.6,5.63-7.74A44.3,44.3,0,0,1,286.2,143.62a35.226,35.226,0,0,1,6.141.229,31.382,31.382,0,0,1,7.824,1.976,24.865,24.865,0,0,1,2.534,1.127c.647.343,1.292.686,1.922,1.078a26.444,26.444,0,0,1,5.851,4.8,21.837,21.837,0,0,1,5.374,9.635c.017.048.017.1.034.147A29.05,29.05,0,0,1,316.049,173.652Z",
    transform: "translate(-254.8 -143.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M305.556,152.31c-1.565.588-4.082-1.094-5.392-1.339-3.657-.653.29,4.556-.085,5.863-.408,1.438-2.279,1.5-3.555,1.356-2.108-.213-3.18-1.633-4.965-2.433a2.106,2.106,0,0,0-3.028,1.47c-.272,1.012,1,3.609.255,4.312-1.123,1.029-4.117-.637-4.916-1.356-1.5-1.339-2.653-3.9-1.819-5.863.221-.621,1.888-.8,2.568-1.175,1.4-.719,2.671-1.634,4.048-2.368a63.893,63.893,0,0,1,5.918-3.267,28.766,28.766,0,0,1,3.2-1.078c.647.343,1.292.686,1.922,1.078A26.443,26.443,0,0,1,305.556,152.31Z",
    transform: "translate(-249.885 -143.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M297.548,145.783a32.373,32.373,0,0,1-3.079,1.373,49.1,49.1,0,0,0-6.7,3.021,32.948,32.948,0,0,0-5.425,3.43c-.969.816-2.143,2.743-2.959,2.743-1.939,2.842-5.987,2.711-8.793,1.454-1.649-.735-2.075-1.927-.2-2.891,2.042-1.045,4.559-1.013,6.684-1.977,1.667-.767,3.181-2.106,2.535-4-.408-1.175-1.769-2.956.288-3.4,1.565-.326,3.385,1.192,4.933,1.47a2.516,2.516,0,0,0,2.976-1.175,5.954,5.954,0,0,1,1.922-2.025A31.382,31.382,0,0,1,297.548,145.783Z",
    transform: "translate(-252.183 -143.535)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.468 29.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.226,182.6c.252,1.55-.335,2.925-1.31,3.071s-1.97-.993-2.221-2.543.335-2.926,1.309-3.071S264.973,181.052,265.226,182.6Z",
    transform: "translate(-259.022 -166.221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.44,180.386c.261,1.607-.441,3.045-1.569,3.215s-2.253-1-2.513-2.6.441-3.044,1.568-3.213S282.178,178.78,282.44,180.386Z",
    transform: "translate(-255.985 -166.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M269.01,191.391a18.824,18.824,0,0,0,6.5-1.623,22.439,22.439,0,0,0,5.384-3.725c.139-.123.388.038.273.2-2.557,3.661-7.653,5.756-12.16,5.588A.221.221,0,1,1,269.01,191.391Z",
    transform: "translate(-257.719 -165.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M269.589,189.242c-1.3-.3-2.622-1.278-2.589-2.683a1.964,1.964,0,0,1,.848-1.613c.427-.275.96-.358,1.4-.615,1.117-.654.572-1.8.262-2.766a17.114,17.114,0,0,0-1.61-4.23c-.113-.17-.46-.122-.433.113a10.4,10.4,0,0,0,.636,2.249q.42,1.185.817,2.377c.132.4.494,1.043.252,1.445a1.511,1.511,0,0,1-.737.458,3.51,3.51,0,0,0-1.4.835,2.664,2.664,0,0,0-.365,2.9,3.629,3.629,0,0,0,2.888,1.793C269.71,189.524,269.741,189.276,269.589,189.242Z",
    transform: "translate(-258.155 -166.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.207,171.689c.352.878-.935.771-2.859,1.315s-2.045,2.226-2.626,2.158-.5-3.021,1.985-4.036C263.608,170.349,264.974,171.109,265.207,171.689Z",
    transform: "translate(-259.425 -167.907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.482,170.033c-.175.789,2.2.463,4.838.286s4.529,1.7,4.827,1.014-1.583-2.9-4.78-2.978S274.6,169.513,274.482,170.033Z",
    transform: "translate(-256.683 -168.352)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.709 34.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M296.089,178.221c1.389-3.569,4.289-6.433,8.441-5.144a4.59,4.59,0,0,1,2.828,2.86,8.2,8.2,0,0,1,.242,4.039,12.381,12.381,0,0,1-5.321,8.614,4.583,4.583,0,0,1-3.832.787c-1.747-.611-2.645-2.474-3.047-4.1A12.416,12.416,0,0,1,296.089,178.221Z",
    transform: "translate(-295.155 -172.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M300.619,174.926c-1.014,1.018-1.566,2.426-2.539,3.42-.683.7-1.121,1.728-2.29.546-.011-.012-.02-.03-.031-.043.071-.21.14-.422.22-.629,1.3-3.343,3.929-6.066,7.668-5.339A8.847,8.847,0,0,0,300.619,174.926Z",
    transform: "translate(-295.044 -172.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M304.147,175.937a2.135,2.135,0,0,0-1.337-.351,3.554,3.554,0,0,0-2.6,1.659,11.907,11.907,0,0,0-1.351,2.945,8.714,8.714,0,0,0-.442,3.276c.013.22.4.215.4-.007a11.279,11.279,0,0,1,1.652-5.244,6.153,6.153,0,0,1,.476-.7,4.886,4.886,0,0,1,.926,2.573,8.029,8.029,0,0,1-.56,3.17.1.1,0,0,0,.181.1,5.053,5.053,0,0,0-.245-6.2,2.717,2.717,0,0,1,1.16-.734,2.039,2.039,0,0,1,2.15.655c.079.119.306.024.266-.115A1.769,1.769,0,0,0,304.147,175.937Z",
    transform: "translate(-294.563 -172.25)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.823 200.191)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 89.229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.728,462.474H18.119L37.068,271.5h15.6Z",
    transform: "translate(-18.119 -271.497)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,462.474H298.4L279.455,271.5h-15.6Z",
    transform: "translate(26.661 -271.497)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.449)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 304.895,
    height: 20.88,
    transform: "translate(6.636 6.021)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 304.893,
    height: 8.171,
    transform: "translate(6.637 6.018)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 318.167,
    height: 10.326
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.988 21.431)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M109.525,195.025h82.982a3.908,3.908,0,0,1,3.658,2.536l22.3,59.521h-89.4L107.115,198.5A2.574,2.574,0,0,1,109.525,195.025Z",
    transform: "translate(-103.92 -195.025)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 132.041,
    height: 6.191,
    transform: "translate(154.151 68.248) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M222.22,252.869c3.358-.666,9.846-2.305,13.533-5.353h2.191v6.191H217.4C219.027,253.464,220.64,253.182,222.22,252.869Z",
    transform: "translate(-83.792 -185.459)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 89.402,
    height: 6.191,
    transform: "translate(111.513 68.248) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ai",
    transform: "translate(25.012 63.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 25.715,
    height: 2.66,
    transform: "translate(51.253)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 5.941,
    height: 2.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 5.941,
    height: 2.66,
    transform: "translate(7.892)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M106.963,195.025h82.981a3.906,3.906,0,0,1,3.658,2.536l22.3,59.521H126.5L104.553,198.5A2.574,2.574,0,0,1,106.963,195.025Z",
    transform: "translate(-104.387 -195.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M106.963,195.025h69.913c-34,.863-52.168,1.893-59.158,2.922s-11.7,2.575-10.477,7.731l-2.688-7.176A2.574,2.574,0,0,1,106.963,195.025Z",
    transform: "translate(-104.387 -195.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M122.957,252.145c18.3,4.965,41.74,3.732,56.362-9.672,7.758-7.111,11.533-17.97,11.381-28.349a50.107,50.107,0,0,0-3.887-19.1h.034a3.906,3.906,0,0,1,3.658,2.536l22.3,59.521H123.4l-2.018-5.386C121.908,251.85,122.434,252,122.957,252.145Z",
    transform: "translate(-101.29 -195.025)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ai",
    transform: "translate(104.424 63.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M192.714,250.4a1.707,1.707,0,1,0,1.707-1.706A1.706,1.706,0,0,0,192.714,250.4Z",
    transform: "translate(-192.714 -248.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M193.192,250.31a1.141,1.141,0,1,0,1.142-1.142A1.141,1.141,0,0,0,193.192,250.31Z",
    transform: "translate(-192.627 -248.604)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.66 11.273)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M163.258,235.283l-6.289-5.047a2.388,2.388,0,0,0-1.952-.549l-6.541,1.439a2.68,2.68,0,0,1-2.961-2.982l1.492-6.524a2.378,2.378,0,0,0-.533-1.954l-5-6.323c-1.2-1.517-.434-3.356,1.3-3.113l7.212,1.016a1.6,1.6,0,0,0,1.622-.659l3.451-5.346c.828-1.283,3.05-.657,3.762,1.058l2.964,7.149A2.94,2.94,0,0,0,163.315,215l7.134,3.019c1.711.724,2.32,2.95,1.029,3.765l-5.379,3.4a1.594,1.594,0,0,0-.673,1.615l.959,7.212C166.613,235.743,164.766,236.493,163.258,235.283Z",
    transform: "translate(-140.89 -204.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M162.821,232.379l-6.8-5.454a.808.808,0,0,0-.663-.186l-7.069,1.553a.909.909,0,0,1-1-1.012l1.613-7.048a.811.811,0,0,0-.182-.663l-5.4-6.833c-.407-.514-.147-1.14.44-1.057l7.793,1.1a.543.543,0,0,0,.551-.223l3.729-5.776c.28-.436,1.036-.223,1.277.358l3.2,7.727a1,1,0,0,0,.521.525l7.709,3.262c.58.246.787,1,.349,1.279l-5.813,3.678a.543.543,0,0,0-.228.549l1.036,7.793C163.961,232.535,163.333,232.789,162.821,232.379Z",
    transform: "translate(-140.484 -204.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.077,222.1l-2.355-1.89a.284.284,0,0,0-.231-.064l-2.45.538a.314.314,0,0,1-.348-.35l.558-2.443a.279.279,0,0,0-.063-.231l-1.873-2.368c-.141-.179-.051-.395.152-.365l2.7.38a.187.187,0,0,0,.192-.078l1.292-2c.1-.15.358-.077.442.124l1.11,2.678a.345.345,0,0,0,.181.182l2.672,1.13c.2.085.272.348.121.443l-2.015,1.274a.189.189,0,0,0-.079.19l.359,2.7C157.471,222.157,157.254,222.245,157.077,222.1Z",
    transform: "translate(-139.185 -202.995)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M138.472,232.907c1.855,6.5,7.959,11.522,13.634,11.218s8.77-5.815,6.914-12.314-7.959-11.522-13.634-11.219S136.616,226.409,138.472,232.907Z",
    transform: "translate(-137.934 -201.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M140.043,232.475c1.517,5.313,6.507,9.419,11.145,9.171s7.169-4.754,5.652-10.067-6.507-9.418-11.145-9.171S138.526,227.164,140.043,232.475Z",
    transform: "translate(-137.629 -201.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M154.24,230.595a.372.372,0,0,0-.61-.162c-.794.648-1.7-.993-2.085-1.462l-2.412-2.946a.7.7,0,0,0-1.173.31,7.222,7.222,0,0,0,.052,2.028c-.113-.171-.215-.351-.336-.517a1.71,1.71,0,0,0-1.931-.876c-.842.332-.872,1.306-.869,2.081a19.053,19.053,0,0,0,1.063,5.526c.141.456.3.908.445,1.362a10.857,10.857,0,0,0,.4,1.29.981.981,0,0,1-.093-.046,2.886,2.886,0,0,1-.449-.356,9.408,9.408,0,0,1-.862-.875,9.026,9.026,0,0,1-1.5-2.452c-.288-.7-.819-1.952-.245-2.629a.338.338,0,0,0-.478-.476c-1.217,1.068-.41,3.1.141,4.307a9.659,9.659,0,0,0,1.4,2.184,4.75,4.75,0,0,0,1.78,1.516,1.108,1.108,0,0,0,1.6-.825,3.773,3.773,0,0,0-.238-1.3c-.14-.526-.287-1.05-.436-1.575a19.848,19.848,0,0,1-1.11-5.854c0-.129,0-.274.018-.4l0-.012c.066.072.15.153.194.21a11.365,11.365,0,0,1,.87,1.407,14.476,14.476,0,0,1,1.227,3.077.711.711,0,0,0,1.389-.188,16.59,16.59,0,0,0-.567-4.325c.7.884,1.412,1.766,2.18,2.578a1.974,1.974,0,0,0,1.819.72A1,1,0,0,0,154.24,230.595Z",
    transform: "translate(-137.098 -200.686)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.855)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.375,213.741c-3.608-2.97-3.9-8.487-2.638-12.635A41.06,41.06,0,0,0,85.33,194.5a12.075,12.075,0,0,0-.236-5.617c.488.789,1.047,1.339,1.548,2.123a16.921,16.921,0,0,1,1.7,3.875,20.138,20.138,0,0,1,1.238,6.449,39.192,39.192,0,0,1-.885,6.346,24.265,24.265,0,0,1-.887,4.185C87.666,212.255,86.964,214.226,86.375,213.741Z",
    transform: "translate(-65.14 -174.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M84.78,212.8a15.1,15.1,0,0,1-8.941-8.642,29.679,29.679,0,0,1-1.423-5.361,18.323,18.323,0,0,1-.424-2.745,2.323,2.323,0,0,0,.792,1.306,25.974,25.974,0,0,0,2.382,2.154A31.257,31.257,0,0,0,79.91,201.7a28.827,28.827,0,0,1,3.152,2.244,13.1,13.1,0,0,1,4.067,6.289,2.961,2.961,0,0,1-.239,2.393A2.175,2.175,0,0,1,84.78,212.8Z",
    transform: "translate(-66.793 -173.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M85.782,211.934c-.664-1,.4-2.893.953-3.666a16.216,16.216,0,0,1,5.487-4.561,51.346,51.346,0,0,1,7.21-2.908,12.951,12.951,0,0,0,3.055-1.311c.484-.331,1.228-.813,1.368-1.43-.011,2.686-1.954,5.029-3.606,6.97a17.224,17.224,0,0,1-6.033,4.672c-1.448.668-2.865,1.246-4.362,1.767a9.507,9.507,0,0,1-2.627.633C86.7,212.126,86.052,212.341,85.782,211.934Z",
    transform: "translate(-64.682 -173.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M102.1,183.885a41.808,41.808,0,0,0-5.386,7.105,84.229,84.229,0,0,0-4.632,8.147,69.277,69.277,0,0,0-6.073,17.228.194.194,0,0,0,.374.1A109.579,109.579,0,0,1,93,199.457a84.623,84.623,0,0,1,4.366-7.663c1.652-2.576,3.559-4.976,5.2-7.554A.294.294,0,0,0,102.1,183.885Z",
    transform: "translate(-64.603 -175.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M84.308,200c-1.451-4.832-3.424-9.93-7.059-13.552-.119-.118-.349.043-.241.186a40.876,40.876,0,0,1,6.41,13.819c1.455,5.288,1.89,10.615,2.469,16.043a.254.254,0,0,0,.507,0C86.957,211.032,85.878,205.229,84.308,200Z",
    transform: "translate(-66.248 -175.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M77.645,192.138a5.1,5.1,0,0,1-2.787-.824,3.357,3.357,0,0,1-1.194-1.957,4.3,4.3,0,0,0-1.512-2.127,6.127,6.127,0,0,0-3.256-1.565c-.239-.028-.917.04-.988-.268-.091-.4.927-.975,1.181-1.1a6.619,6.619,0,0,1,2.763-.618c.669-.007,1.376.372,2.018.284a3.875,3.875,0,0,1-1.29-2.541c-.057-.844.233-2.577,1.194-2.912.7-.245.681.852.767,1.3a5.233,5.233,0,0,0,1.143,2.674c-.006-1.253.686-3.1,1.991-3.5.074.8-.549,1.719-.238,2.529a3.8,3.8,0,0,1,1-1.274c.272-.22.7-.737,1.083-.708a5.425,5.425,0,0,0-.286,1.9c-.058,1.29.98,1.795,1.792,2.623a5.931,5.931,0,0,1,1.267,1.393,5.314,5.314,0,0,1,.281,2.911C82.36,189.921,81.011,192.038,77.645,192.138Z",
    transform: "translate(-67.902 -176.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M107.3,181.431c.158-.051.471-.063.515-.246.131-.538-1.59-.806-1.864-.865a4.755,4.755,0,0,0-1.868.034c-.2.039-.563.238-.644.017-.074-.2.34-.844.422-1.017.131-.275.394-.624.345-.943a2.589,2.589,0,0,0-2.389,1.44c-.436-.611-.592-1.414-1.076-2.024a2.608,2.608,0,0,0-.914-.82c-.184-.076-.685-.181-.867-.037s-.123.525-.108.722a6.861,6.861,0,0,1-.006,2.121c-.216.88-.855,1.071-1.559,1.481a4.947,4.947,0,0,0-1.231,1.063,3.64,3.64,0,0,0-.891,2.123,4.854,4.854,0,0,0,1.955,3.872,6.127,6.127,0,0,0,1.007.673c2.225,1.185,5.561,1.719,6.87-1.024a6.886,6.886,0,0,0,.441-3.667,1.143,1.143,0,0,1,.069-.606,1.433,1.433,0,0,1,1-.592c.291-.066.824-.2.344-.484-.384-.232-.93-.064-1.349-.085a4.9,4.9,0,0,1,1.037-.774A3.843,3.843,0,0,1,107.3,181.431Z",
    transform: "translate(-62.936 -176.897)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.094 38.161)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M105.877,237.53a12.3,12.3,0,0,0-6.864-11.594,8.287,8.287,0,0,1-4.613-7.3V209.7H82.842v8.939a8.286,8.286,0,0,1-4.613,7.3,12.3,12.3,0,0,0-6.864,11.594,22.7,22.7,0,0,0,3.2,11.154c1.829,3.138,6.195,6.709,6.195,10.342H96.479c0-3.633,4.367-7.2,6.195-10.342A22.682,22.682,0,0,0,105.877,237.53Z",
    transform: "translate(-71.365 -209.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 14.043,
    height: 2.125,
    rx: 0.622,
    transform: "translate(10.234)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 18.01,
    height: 2.081,
    rx: 0.609,
    transform: "translate(8.251 49.176)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.691250d33fb64e45a5ce39286f83adc9.svg";
export { ForwardRef as ReactComponent };